<template>
  <v-app class="bckgrnd">
    <v-breadcrumbs large :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon size="25">keyboard_arrow_right</v-icon>
      </template>
    </v-breadcrumbs>

   <v-container>
           <v-container>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
           <v-flex xs12 sm12 md8>
             <v-text-field outline style="background-color:white;height:56px" v-model="form.name" label="Product Title *" :rules="emptyRule" required></v-text-field>
             
             <v-autocomplete
              outline style="background-color:white;height:56px;margin-top:15px"
                    v-model="selectedManufacturer"
                    :items="manufacturers"
                    color="primary"
                    label="Manufacturer *"
                    item-text="name"
                    item-value="id"
                  ></v-autocomplete>

             <v-card flat style="background-color:white;margin-top:15px;">
               <v-textarea outline style="padding:10px" :auto-grow="true" v-model="form.description" :rules="emptyRule" required label="Description"></v-textarea>
             </v-card>

             <v-card flat style="background-color:white;margin-top:15px;">
              <v-tabs v-model="tab" grow>
                <v-tab style="background-color:#e0e0e0;font-size:11px">
                  General
                </v-tab>
                <v-tab style="background-color:#e0e0e0;font-size:11px">
                  Inventory
                </v-tab>
                <v-tab style="background-color:#e0e0e0;font-size:11px">
                  Shipping
                </v-tab>
                <v-tab style="background-color:#e0e0e0;font-size:11px">
                  Attributes
                </v-tab>
                <v-tab style="background-color:#e0e0e0;font-size:11px">
                  Advanced
                </v-tab>
                <v-tab style="background-color:#e0e0e0;font-size:11px">
                  Get more options
                </v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab">
                <v-tab-item style="padding:20px">
                  <v-text-field type="number" v-model="form.regularPrice" label="Regular Price"></v-text-field>
                  <v-text-field type="number" v-model="form.salePrice" label="Sale Price"></v-text-field>
                </v-tab-item>
                <v-tab-item style="padding:20px">
                  <v-text-field v-model="form.sku" label="SKU"></v-text-field>
                  <b-form-checkbox v-model="form.manageStock">Enable stock management at product level</b-form-checkbox>
                  <v-text-field v-if="form.manageStock==true" type="number" v-model="form.stockQty" label="Stock Qty"></v-text-field>
                  <v-autocomplete
                    v-if="form.manageStock==true"
                    v-model="selectedAllow"
                    :items="allows"
                    color="primary"
                    label="Allow backorders ? *"
                    item-text="allows"
                    item-value="allows"
                  ></v-autocomplete>
                  <v-text-field v-if="form.manageStock==true" v-model="form.lowStockThershold" label="Low stock threshold"></v-text-field>
                  <b-form-checkbox v-model="form.soldIndividually">Enable this to only allow one of this item to be bought in a single order</b-form-checkbox>
                </v-tab-item>

                <v-tab-item style="padding:20px">
                  <v-text-field v-model="form.weight" label="Weight"></v-text-field>
                  <v-text-field v-model="form.length" label="Length"></v-text-field>
                  <v-text-field v-model="form.width" label="Width"></v-text-field>
                  <v-text-field v-model="form.height" label="Height"></v-text-field>
                  <v-text-field v-model="form.shippingClass" label="Shipping Class"></v-text-field>
                </v-tab-item>

                <v-tab-item style="padding:20px">
                  <div style="text-align:right">
                    <v-dialog v-model="detailDialog" max-width="500px" persistent>
                  <v-btn color="#212121" dark depressed small slot="activator">Add new</v-btn>
                  <v-card style="border-radius: 10px">
                      <v-card-text>
                          <v-container grid-list-md>
                              <v-layout wrap>
                                  <v-flex xs12>
                                   <v-text-field v-model="editedItem.name" label="Name"></v-text-field>
                                  </v-flex>
                                  <v-flex xs12>
                                   <v-text-field v-model="editedItem.value" label="Value"></v-text-field>
                                  </v-flex>
                                  <v-flex xs12>
                                    <b-form-checkbox v-model="editedItem.visible">Visible on the product page</b-form-checkbox>
                                  </v-flex>
                              </v-layout>
                          </v-container>
                      </v-card-text>
                      <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" flat @click="close()">Cancel</v-btn>
                    <v-btn v-if="editedItem.name != null && editedItem.value != null" color="success" flat @click="save()">Save</v-btn>
                  </v-card-actions>
                  </v-card>
              </v-dialog>
                  </div>
                  <v-data-table
              :headers="headers"
              :items="itemAdded"
              :disable-initial-sort="true"
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.index + 1 }}</td>
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-left">{{ props.item.value }}</td>
                <td class="justify-center">
                  <v-icon color="error" class="ml-3" small @click="deleteItem(props.item)">delete</v-icon>
                </td>
              </template>
            </v-data-table>
                </v-tab-item>

                <v-tab-item style="padding:20px">
                  <v-textarea outline v-model="form.purchaseNote" :auto-grow="true" rows="5" row-height="15" label="Purchase note"></v-textarea>
                  <v-text-field v-model="form.menuOrder" label="Menu order"></v-text-field>
                  <b-form-checkbox v-model="form.enableReviews">Enable reviews</b-form-checkbox>
                </v-tab-item>

                <v-tab-item style="padding:20px">
                  <v-text-field v-model="form.min" label="Specify minimum allowed product quantities for orders to be completed"></v-text-field>
                  <v-text-field v-model="form.max" label="Specify maximum allowed product quantities for orders to be completed"></v-text-field>
                </v-tab-item>
              </v-tabs-items>
             </v-card>
           </v-flex>

           <v-flex xs12 sm12 md4 style="padding-left:5px;">
             <v-card flat>
                <h6 style="text-align:center;padding-bottom:20px;padding-top:20px;background-color:#e0e0e0">Product Categories</h6>

               <div class="scroll" style="padding:25px">
                 <b-form-checkbox
                 v-for="item in categories1" :key="item.id"
                v-model="item.status"
                @change="save1(item)"
              >
                {{item.categoryName}}
              </b-form-checkbox>
               </div>
               <h6 style="text-align:center;padding-bottom:20px;padding-top:20px;background-color:#e0e0e0" class="hvr" @click="go()">Add Product Categories</h6>
             </v-card>

             <v-card flat style="margin-top:10px;">
               <h6 style="text-align:center;padding-bottom:20px;padding-top:20px;background-color:#e0e0e0">Product Image</h6>
               <input style="padding:10px" type="file" ref="myFile" @change="selectedFile"  class="padding" accept="image/*">
               <h6 style="padding:10px" v-if="imagelink != null">Image Size : {{image.size}}</h6>
               <h6 style="padding:10px" class="red--text">{{imageError}}</h6>
             </v-card>
           </v-flex>

           <v-flex xs12 style="margin-top:10px;text-align:right">
             <v-card flat>
               <v-btn depressed :loading="btnSave" color="#e53935" dark @click="onSubmit()">Save</v-btn>
               <v-btn depressed color="black" dark @click="back()">Cancel</v-btn>
             </v-card>
           </v-flex>
        </v-layout>
      </v-form>
      </v-container>
   </v-container>
    
  </v-app>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      tab: null,
      dialog: false,
      categoryDialog: false,
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,
      btnSave1: false,
      dateModel: false,
      detailDialog: false,

      imagelink: null,
      imageError:'',

      allows: ["Do not allow", "Allow, but notify customer", "Allow"],
      selectedAllow: "Do not allow",

      editedItem: {
        name: null,
        value: null,
        visible: true
      },

      //selectedFile: null,

      valid: true,

      image:{
      size:'',
      height:'',
      width:''
    },
    imageLoaded:false,

    date1: new Date(),


      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
      },
      valid: true,
      roleType: sessionStorage.roles,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Product",
          disabled: false,
          to: "/product"
        },
        {
          text: "Add Item",
          disabled: true,
          to: "/createStudent"
        }
      ],

      categories1: [],
      selectedCategory: null,


      form: {
          name: null,
          description: null,
          regularPrice: 0,
          salePrice: 0,
          sku: null,
          manageStock: false,
          stockQty: 0,
          allowBackorder: null,
          lowStockThershold: null,
          soldIndividually: false,
          weight: null,
          length: null,
          width: null,
          height: null,
          shippingClass: null,
          purchaseNote: null,
          menuOrder: 0,
          enableReviews: false,
          min: 0,
          max: 0
      },

      manufacturers: null,
      selectedManufacturer: null,

      formc: {
          name: null,
      },

      itemAdded: [],
      itemAdded1: [],

      headers: [
        { text: "#", value: "#" },
        { text: "Name", value: "name" },
        { text: "Value", value: "value" },
        { text: "Remove", value: "remove" }
      ],
    };
  },

  mounted() {
    this.getData();
      this.axios
        .get(config.API + "Categories", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.categories1 = res.data;
          this.$Progress.finish();
        })
        .catch(err => {
          this.$Progress.fail();
        });
    },

  methods: {
    back() {
      this.$router.go(-1);
    },

    getData() {
        this.axios
        .get(config.API + "Manufacturers", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.manufacturers = res.data;
        });
    },

    submit() {
    if (this.$refs.formc.validate()) {
        this.btnSave1 = true;
      this.axios
          .post(
            config.API + "Manufacturers",
            {
              name: this.formc.name
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
              this.getData();
            this.$toaster.success("Successfully added");
            this.formc.name = null;
            this.dialog = false;
            this.btnSave1 = false;
          })
          .catch(err => {
            console.log(err.message);
            this.btnSave1 = false;
          });
    }
    },

    close() {
      this.detailDialog = false;
      this.editedItem.detail = null;
    },
    deleteItem(item) {
      if(confirm("Are you sure you want to delete this selection?")) {
         const index = this.itemAdded.indexOf(item);
         this.itemAdded.splice(index, 1);
      }
    },

    save() {
            let lth = this.itemAdded.length;
            if (lth == 0) {
              this.itemAdded.push({
              name: this.editedItem.name,
              value: this.editedItem.value,
              visible: this.editedItem.visible
              });

              this.close();
            }
            else {
                let flag = false;

                for(let i = 0; i < lth; i++) {
                    let _qus = this.itemAdded[i].name;

                    if(_qus == this.editedItem.name) {
                        flag = true;
                    }
                }

                if (flag == true) {
                this.$toaster.error(`Already Added!!`);
               }
               else {
                   this.itemAdded.push({
              name: this.editedItem.name,
              value: this.editedItem.value,
              visible: this.editedItem.visible
              });

              this.close();
               }
            }
        
      },

      save1(item) {
        if(item.status == false) {
            this.itemAdded1.push({
                categoryId: JSON.parse(item.id)
            });
            console.log(this.itemAdded1);
        }
        else {
         const index = this.itemAdded1.indexOf(item);
         this.itemAdded1.splice(index, 1);
         console.log(this.itemAdded1);
        }
    },

    selectedFile() {
      this.imageLoaded = false;
      this.imageError = '';

      let file = this.$refs.myFile.files[0];
      this.imagelink = file;
      if(!file || file.type.indexOf('image/') !== 0) return;
      
      this.image.size = file.size;

      if(this.image.size > 500000) {
        this.imageError = `The image size (${this.image.size}) is too much (max is 500 KB).`;
        return;
      }
      
      let reader = new FileReader();
      
      reader.readAsDataURL(file);
      reader.onload = evt => {
        let img = new Image();
        img.onload = () => {
          this.image.width = img.width;
          this.image.height = img.height;
          this.imageLoaded = true;
        }
        img.src = evt.target.result;
      }

      reader.onerror = evt => {
        console.error(evt);
      }
    },

    onSubmit() {
      /* let code = "PP" + this.date1.getFullYear() + this.date1.getMonth() + Math.floor(100000 + Math.random() * 900000);
       console.log({
         code: code,
              name: this.form.name,
              manufacturerId: JSON.parse(this.selectedManufacturer),
              description: this.form.description,
              regularPrice: JSON.parse(this.form.regularPrice),
              salePrice: JSON.parse(this.form.salePrice),
              sku: this.form.sku,
              manageStock: this.form.manageStock,
              stockQty: JSON.parse(this.form.stockQty),
              allowBackorder: this.selectedAllow,
              lowStockThershold: this.form.lowStockThershold,
              soldIndividually: this.form.soldIndividually,
              weight: this.form.weight,
              length: this.form.length,
              width: this.form.width,
              height: this.form.height,
              shippingClass: this.form.shippingClass,
              purchaseNote: this.form.purchaseNote,
              menuOrder: JSON.parse(this.form.menuOrder),
              enableReviews: this.form.enableReviews,
              min: JSON.parse(this.form.min),
              max: JSON.parse(this.form.max),
              attributes: this.itemAdded,
              productCategories: this.itemAdded1
       }); */
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        let code = "PP" + this.date1.getFullYear() + this.date1.getMonth() + Math.floor(100000 + Math.random() * 900000);
        this.axios
          .post(
            config.API + `Products`,
            {
              code: code,
              name: this.form.name,
              manufacturerId: JSON.parse(this.selectedManufacturer),
              description: this.form.description,
              regularPrice: JSON.parse(this.form.regularPrice),
              salePrice: JSON.parse(this.form.salePrice),
              sku: this.form.sku,
              manageStock: this.form.manageStock,
              stockQty: JSON.parse(this.form.stockQty),
              allowBackorder: this.selectedAllow,
              lowStockThershold: this.form.lowStockThershold,
              soldIndividually: this.form.soldIndividually,
              weight: this.form.weight,
              length: this.form.length,
              width: this.form.width,
              height: this.form.height,
              shippingClass: this.form.shippingClass,
              purchaseNote: this.form.purchaseNote,
              menuOrder: JSON.parse(this.form.menuOrder),
              enableReviews: this.form.enableReviews,
              min: JSON.parse(this.form.min),
              max: JSON.parse(this.form.max),
              attributes: this.itemAdded,
              productCategories: this.itemAdded1
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {

            if(this.imagelink != null) {
              const fd = new FormData();
            fd.append("image", this.imagelink, this.imagelink.name);
         this.axios
        .post(config.API + `ItemImage/${code}`, fd, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(() => {
          this.$toaster.success("Successfully added");
            this.$router.go(-1);
        })
        .catch(err => {
          this.$toaster.error(err.message);
          this.btnSave = false;
        });
            }
            else {
              this.$toaster.success("Successfully added");
              this.$router.go(-1);
            }
            
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    go(){
      this.$router.push("/createItemCategory");
    }
  },

  computed: {
    categories: function() {
      return this.categories1.filter(srch => {
        return (
          srch.parent == 0
        );
      });
    },
  },
};
</script>

<style>
.bckgrnd {
  background-color: #424242;
  background-size:cover !important;
}
div.scroll { 
                margin:4px, 4px; 
                padding:4px; 
                width: auto; 
                height: 254px; 
                overflow-x: hidden; 
                overflow-x: auto; 
                text-align:justify; 
            } 
</style>
